export default __webpack_public_path__ + "static/char-29-4cbfeb30ed675add06a193c56c6fb7c9.webp";